// Small geodesy helpers shared by the report maps.

export function haversineKm(lat1, lng1, lat2, lng2) {
  const R = 6371, toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1), dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

// "3km" | "10km" | 3 -> 3
export function radiusToKm(radius) {
  const n = parseFloat(String(radius ?? ""));
  return Number.isFinite(n) && n > 0 ? n : null;
}

// Reports generated before the backend held its lists to the scan radius can carry
// "competitors" from other continents — a biased Google search padding a thin
// category. Those rows drag every map out to a globe and are not competitors in any
// sense, so the report drops them on display. 1.5x the radius is the slack: the
// scan origin is a cell centre, and a rival just past the ring is still a rival.
export function withinRadius(analysis, radius, center) {
  const km = radiusToKm(radius);
  if (!analysis || !km || !Number.isFinite(center?.lat) || !Number.isFinite(center?.lng)) return analysis;
  const ok = (p) => !Number.isFinite(p?.lat) || !Number.isFinite(p?.lng)
    || haversineKm(center.lat, center.lng, p.lat, p.lng) <= km * 1.5;
  return {
    ...analysis,
    competitors: (analysis.competitors || []).filter(ok),
    ecosystem: (analysis.ecosystem || []).map((e) => ({ ...e, places: (e.places || []).filter(ok) })),
  };
}
